// MOCK DATA - všetky dáta sú zatiaľ statické (frontend-only).
// Neskôr sa nahradí backendom / reálnym obsahom.

export const candidate = {
  firstName: "Ján",
  lastName: "Kuráň",
  fullName: "Ján Kuráň",
  role: "Kandidát na primátora",
  city: "Ružomberok",
  ballotNumber: "3",
  tagline: "MESTO PRE ĽUDÍ",
  leadLine: "Ružomberok má na viac.",
  subTagline:
    "Chcem z neho urobiť mesto, kde sa dá dobre bývať, slušne zarobiť a dobre žiť.",
  photo:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/v8t6oahi_IMG_3328.webp",
};

export const electionDate = "2026-10-24T07:00:00"; // Voľby 24.10.2026

export const nav = [
  { label: "Domov", href: "/" },
  { label: "O mne", href: "/o-mne" },
  { label: "Priority", href: "/#priority" },
  { label: "Vízie", href: "/#manifest" },
  { label: "Program", href: "/program" },
  { label: "Stretnutia", href: "/#stretnutia" },
  { label: "Aktuality", href: "/aktuality" },
  { label: "Podpora", href: "/#podpora" },
];

export const tickerItems = [
  "MESTO PRE ĽUDÍ",
  "RUŽOMBEROK MÁ NA VIAC",
  "VIAC BÝVANIA",
  "VIAC PRÁCE",
  "VIAC ŽIVOTA V MESTE",
  "VOĽBY 24. 10. 2026",
  "VOLEBNÉ ČÍSLO 3",
];

export const about = {
  heading: "O mne",
  paragraphs: [
    "Volám sa Ján Kuráň. Som Ružomberčan a jeden z ľudí, ktorým záleží na tom, kam sa naše mesto bude uberať.",
    "Táto kampaň však nie je o mne. Ja som len nositeľom myšlienky, že Ružomberok môže byť lepším mestom pre nás všetkých.",
    "Nechcem, aby politika bola o jednom človeku, jednej tvári alebo jednom mene. Mesto netvorí primátor. Mesto tvoria ľudia, ktorí v ňom žijú, pracujú, vychovávajú deti, podnikajú, učia, pomáhajú druhým a každý deň mu dávajú život.",
    "Som jeden z vás. Mám rovnaké otázky, obavy aj nádej, že veci sa dajú robiť lepšie.",
    "Kandidujem preto, pretože verím, že človek, ktorý chce viesť mesto, nemá stáť nad ľuďmi. Má medzi nimi chodiť, počúvať ich, spájať ich a niesť zodpovednosť za smer, na ktorom sa spoločne dohodneme.",
    "Nechcem, aby ste verili v jedného politika. Chcem, aby sme znovu verili v Ružomberok.",
    "Ak dostanem dôveru, budem človekom, ktorý túto spoločnú predstavu bude každý deň premieňať na prácu.",
    "Pretože tento príbeh nie je o mne. Je o nás. A o meste, ktoré voláme domov.",
  ],
  bullets: [
    "Viac bývania – 1000 nových bytov do roku 2036",
    "Viac práce – 3000 nových pracovných miest do roku 2036",
    "Živé centrum a fungujúce mesto od základov",
    "Transparentná a otvorená radnica",
  ],
  // Fotky Ružomberka v slideshow (dopĺňajú sa po dávkach až do 42).
  townPhotos: [
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/xqpdibz9_DJI_20260804003909_0066_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/olg1qi4k_DJI_20260804004027_0070_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/f4jcbhkc_DJI_20260804004227_0077_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/57yzwkqo_DJI_20260804004612_0084_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/02ul6jh9_DJI_20260804014204_0102_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/c26ye406_DJI_20260804014206_0103_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/6c1h4iw1_DJI_20260804014219_0106_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/0n3l989k_DJI_20260804014321_0109_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/4ptm94np_DJI_20260804014324_0110_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/5logo8c8_DJI_20260804014532_0115_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/jqkjakj8_DJI_20260807013512_0001_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/aqvovcvk_DJI_20260807013607_0004_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/qx01y8kh_DJI_20260804134358_0122_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/u1dg58rb_DJI_20260804134404_0124_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/yyh2nooh_DJI_20260804235437_0131_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/qmc7zwjq_DJI_20260807013750_0011_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/40rancc2_DJI_20260807013757_0012_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/94k46rdz_DJI_20260807013840_0016_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/zex4pz36_DJI_20260820205652_0019_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/n1wita0h_DJI_20260820205834_0023_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/z9vjh9np_P1140497.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/c2s4szew_DSC05581.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/yok1xozf_DJI_20260824013055_0026_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/t4aw9yvf_DJI_20260824012841_0015_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/fsc4k5pd_DJI_20260820210128_0031_D.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/06gtjnd3_P1140503.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/ynpbbkcb_Ruzomberok%20Malino%20foto_-2.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/edxozb55_Ruzomberok%20Malino%20foto_-3.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/9iegxplk_Ruzomberok%20Malino%20foto_-4.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/rfkfbopk_Ruzomberok%20Malino%20foto_-7.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/miezzyl9_Ruzomberok%20Malino%20foto_-15.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/xc30jwei_Ruzomberok%20Malino%20foto_-16.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/h245kums_Ruzomberok%20Malino%20foto_-24.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/un3ds5fn_Ruzomberok%20Malino%20foto_-28.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/ksybjl5y_Ruzomberok%20Malino%20foto_-96.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/6geuknl6_Ruzomberok%20Malino%20foto_-97.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/ibyqqfqc_Ruzomberok%20Malino%20foto_-98.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/88cq8bss_Ruzomberok%20Malino%20foto_-99.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/hsqi38xt_Ruzomberok%20Malino%20foto_-101.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/zv4gpevd_Ruzomberok%20Malino%20foto_-103.webp",
  ],
};

export const visions = {
  heading: "Moje vízie vo videu",
  intro:
    "Namiesto čítania ďalších odsekov si môžete priamo pozrieť moje predstavy o meste. Postupne tu pribudnú videá k jednotlivým témam.",
  // Do každej karty doplňte video URL alebo embed kód (YouTube/Facebook).
  // Nechajte prázdne "", kým video nie je hotové – zobrazí sa placeholder.
  cards: [
    {
      title: "Práca – chlieb aj ruže",
      text:
        "Ružomberok potrebuje prácu, z ktorej sa dá slušne žiť. Mojím cieľom je vytvoriť podmienky pre 3000 nových pracovných miest do roku 2036.",
      videoUrl: "https://youtu.be/-698e9qMoek",
    },
    {
      title: "Pripravení na klimatickú zmenu",
      text:
        "Klimatická zmena je realita a Ružomberok na ňu musí byť pripravený – viac stromov a tieňa, vodozádržné opatrenia a rozumná ochrana prírody pre zdravšie mesto pre ďalšie generácie.",
      videoUrl: "https://youtu.be/4IxrFoxi9CA",
    },
    {
      title: "Fungujúce mesto od základov",
      text:
        "Veľké vízie nestačia, ak nefungujú chodníky, cesty, ihriská či základná údržba mesta. Chcem, aby mesto kontrolovalo kvalitu práce a problémy riešilo systematicky.",
      videoUrl: "https://youtu.be/TDKhmrY5HSQ",
    },
  ],
};

export const priorities = {
  heading: "Moje priority",
  items: [
    {
      no: "01",
      icon: "Home",
      title: "1000 nových bytov",
      text:
        "Vytvoríme podmienky na vznik 1000 nových bytov do roku 2036. Dostupné družstevné a nájomné bývanie pre mladých ľudí, rodiny a seniorov.",
    },
    {
      no: "02",
      icon: "Briefcase",
      title: "3000 nových pracovných miest",
      text:
        "Vytvoríme podmienky na vznik 3000 nových pracovných miest do roku 2036. Budeme aktívne získavať menších a stredných investorov a podporovať ľudí, ktorí už dnes v Ružomberku podnikajú.",
    },
    {
      no: "03",
      icon: "Bus",
      title: "Lepšia MHD a fungujúce mesto",
      text:
        "Lepšie spojenia, rozumné parkovanie, opravené cesty, chodníky a kvalitnejšie verejné priestory.",
    },
  ],
};

export const program = {
  bigHeading: "Viac ľudí. Silnejšie mesto. Lepší život tu doma.",
  heading: "Program pre Ružomberok",
  subheading: "Osem oblastí, na ktorých začneme pracovať od prvého dňa.",
  pdfUrl:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/xlhuipgc_kuran_program2026final.pdf",
  pdfFileName: "Program-Jan-Kuran-2026.pdf",
  items: [
    {
      no: "01",
      icon: "Home",
      title: "Dostupné bývanie",
      subtitle: "1000 nových bytov do roku 2036.",
      bullets: [
        "Družstevné a nájomné byty pre mladých, rodiny a seniorov.",
        "Jasné podmienky a férové pravidlá.",
        "Pripravený od prvého dňa.",
      ],
      conclusion: "Aby naše deti nemuseli odchádzať a mohli tu zostať.",
    },
    {
      no: "02",
      icon: "Briefcase",
      title: "Práca a slušné mzdy",
      subtitle: "3000 nových pracovných miest do roku 2036.",
      bullets: [
        "Aktívne získavanie investorov a podpora miestnych firiem.",
        "Tím na rozvoj pracovných miest s jasným cieľom.",
        "Viac príležitostí pre mladých, aby tu mali svoju budúcnosť.",
      ],
      conclusion: "Ružomberok, kde sa dá slušne zarobiť a žiť dôstojne.",
    },
    {
      no: "03",
      icon: "Bus",
      title: "MHD pre ľudí",
      subtitle: "Spoľahlivá, dostupná, udržateľná.",
      bullets: [
        "Optimalizácia liniek a návrat spojenia do všetkých častí mesta.",
        "Moderné zastávky so zelenými strechami.",
        "Navýšenie dotácie mesta na 100 %.",
      ],
      conclusion: "Mesto, ktoré spája ľudí, nie ich rozdeľuje.",
    },
    {
      no: "04",
      icon: "Store",
      title: "Živé centrum",
      subtitle: "Mesto, kde to žije.",
      bullets: [
        "Viac zelene, kvalitný verejný priestor.",
        "Podpora lokálnych prevádzok a podnikateľov.",
        "Dotácia pre kultúrne akcie v meste.",
        "Čistota, koše, funkčné verejné WC.",
      ],
      conclusion: "Centrum, ktoré žije počas celého dňa.",
    },
    {
      no: "05",
      icon: "Construction",
      title: "Kvalitné cesty, chodníky a ihriská",
      subtitle: "Bezpečné a udržiavané.",
      bullets: [
        "Systematická údržba a kontrola prác.",
        "Bezpečné chodníky, cesty, priechody.",
        "Moderné ihriská a športoviská pre deti a dospelých.",
        "Koniec s provizórnymi riešeniami.",
      ],
      conclusion: "Funkčné mesto začína od základov.",
    },
    {
      no: "06",
      icon: "ScrollText",
      title: "Transparentné a otvorené mesto",
      subtitle: "Viac dôvery. Menej káuz.",
      bullets: [
        "Zverejňovanie zmlúv nad rámec zákona.",
        "Transparentné výberové konania.",
        "Aplikácia pre podnety, informácie a rozhodnutia mesta.",
        "Pravidelný dialóg s občanmi vo všetkých častiach mesta.",
      ],
      conclusion:
        "O meste sa rozhoduje s ľuďmi, nie za zatvorenými dverami.",
    },
    {
      no: "07",
      icon: "Users",
      title: "Mesto pre rodiny, deti a seniorov",
      subtitle: "Lepšie služby v každej etape života.",
      bullets: [
        "Mestské jasle a modernizácia škôlok.",
        "Podpora rodín, inklúzie a dostupných sociálnych služieb.",
        "Fond pomoci pre rodiny so zdravotne znevýhodnenými deťmi.",
        "Kultúrne a sociálne podujatia pre seniorov, aby sa necítili osamelo.",
      ],
      conclusion:
        "Silné mesto sa meria tým, ako sa stará o najzraniteľnejších.",
    },
    {
      no: "08",
      icon: "Trees",
      title: "Zelenší a odolnejší Ružomberok",
      subtitle: "Pripravení na budúcnosť.",
      bullets: [
        "Viac stromov, tieňa a vodozádržných opatrení.",
        "Adaptácia na klimatickú zmenu.",
        "Ochrana prírody a rozumný turizmus – Vlkolínec, Čutkovská dolina, Hrabovo.",
        "Zdravšie mesto pre ďalšie generácie.",
      ],
      conclusion: "Krajšie, zdravšie a silnejšie mesto pre naše deti.",
    },
  ],
};

export const transparentAccount = {
  heading: "Transparentný účet",
  text: "Kampaň financujú ľudia, nie skryté záujmy. Každé euro je verejne dohľadateľné. Podporte kampaň Jána Kuráňa.",
  bank: "VÚB banka",
  iban: "SK54 0200 0000 0072 4300 2555",
  url: "https://payme.sk/?V=1&IBAN=SK5402000000007243002555&AM=0&CC=EUR",
};

export const social = [
  {
    label: "Facebook",
    href: "https://www.google.com/goto?url=CAEScQHrOzAV6knV41eM6yeqqXhwSmBml1M7k-VqnV4OnLERFuVZZxn_S4eqXejJeDBxtQYnyGBI-Lf3BbQR63wcZ-zQNYkaSnuBujHYt0fbavUzIWuPRHwoARWD_WGdbanC3kL-eWyh4fmbRKnnI2nRBSr-",
    icon: "Facebook",
  },
  { label: "YouTube", href: "https://www.youtube.com/@jankuran2087", icon: "Youtube" },
];

// STRETNUTIA S OBČANMI – rozpis
export const meetings = {
  heading: "Stretnutia s občanmi",
  subheading: "Rozhovory o meste",
  intro: "Príďte sa porozprávať o budúcnosti Ružomberka. Teším sa na osobné stretnutie a vaše otázky, názory a podnety.",
  events: [
    { date: "01. 10. 2026", place: "Polík", venue: "Anima Café", time: "18:00" },
    { date: "02. 10. 2026", place: "Vlkolínec", venue: "Reštaurácia Vlkolínec", time: "18:00" },
    { date: "03. 10. 2026", place: "Roveň", venue: "London Pizza", time: "11:00" },
    { date: "03. 10. 2026", place: "Hrboltová", venue: "KD Hrboltová", time: "18:00" },
    { date: "08. 10. 2026", place: "Biely Potok", venue: "KD Biely Potok", time: "18:00" },
    { date: "09. 10. 2026", place: "Černová", venue: "KD Černová", time: "18:00" },
    { date: "10. 10. 2026", place: "Rybárpole", venue: "", time: "15:00" },
    { date: "11. 10. 2026", place: "Roveň", venue: "Gamestore", time: "13:00" },
    { date: "15. 10. 2026", place: "Baničné", venue: "Bodka", time: "18:00" },
    { date: "17. 10. 2026", place: "Klačno", venue: "Detské ihrisko pri kostole", time: "15:00" },
    { date: "17. 10. 2026", place: "Roveň", venue: "Roveň Pub Kocka", time: "18:00" },
    { date: "21. 10. 2026", place: "Hlavný míting", venue: "KD Andreja Hlinku", time: "18:00", highlight: true },
  ],
};

export const contactInfo = {
  email: "jan@kuranpreruzomberok.sk",
  phone: "+421 944 937 797",
  address: "Ružomberok, Slovensko",
};

// AKTUALITY Z KAMPANE — ukážkové príspevky (mock), na neskoršie doplnenie reálnych noviniek.
export const news = [
  {
    slug: "spustili-sme-kampan-mesto-pre-ludi",
    date: "2026-09-01",
    dateLabel: "1. september 2026",
    title: "Spustili sme kampaň Mesto pre ľudí",
    excerpt:
      "Predstavujeme kampaň Jána Kuráňa, kandidáta na primátora Ružomberka. Jej ústrednou myšlienkou je mesto, kde sa dá dobre bývať, slušne zarobiť a dobre žiť.",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/xqpdibz9_DJI_20260804003909_0066_D.webp",
    body: [
      "Kampaň Jána Kuráňa vstupuje do verejného priestoru s jasným posolstvom – Ružomberok má na viac. Cieľom je vytvoriť mesto, kde ľudia nemusia odchádzať a kde má zmysel zostať, pracovať a založiť si rodinu.",
      "V najbližších týždňoch budeme postupne predstavovať jednotlivé oblasti programu a stretávať sa s obyvateľmi vo všetkých častiach mesta.",
    ],
  },
  {
    slug: "zverejnili-sme-kompletny-volebny-program",
    date: "2026-09-10",
    dateLabel: "10. september 2026",
    title: "Zverejnili sme kompletný volebný program",
    excerpt:
      "Celý volebný program je dostupný online v čitateľnej HTML podobe aj na stiahnutie v PDF. Program je rozdelený do 20 oblastí.",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/qx01y8kh_DJI_20260804134358_0122_D.webp",
    body: [
      "Volebný program Jána Kuráňa pre Ružomberok 2026–2030 je od dnešného dňa dostupný verejne na webe. Nájdete v ňom konkrétne opatrenia v oblasti bývania, práce, dopravy, verejného priestoru, školstva, sociálnych služieb, turizmu, klímy aj fungovania mesta.",
      "Program si môžete prečítať priamo na stránke alebo stiahnuť vo formáte PDF.",
    ],
  },
  {
    slug: "pozyvame-vas-na-stretnutia-v-mestskych-castiach",
    date: "2026-09-18",
    dateLabel: "18. september 2026",
    title: "Pozývame vás na stretnutia v mestských častiach",
    excerpt:
      "Pripravujeme sériu verejných stretnutí s obyvateľmi vo všetkých častiach mesta. Konkrétne termíny a miesta budú doplnené čoskoro.",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/z9vjh9np_P1140497.webp",
    body: [
      "Chceme počúvať ľudí tam, kde žijú. Preto pripravujeme verejné stretnutia priamo v jednotlivých mestských častiach a na sídliskách.",
      "Sledujte túto sekciu aj naše sociálne siete – termíny a miesta stretnutí zverejníme čoskoro.",
    ],
  },
];

